import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormsService, SettingsService, SubtitlesService} from "../../../core";
import {FormControl} from "@angular/forms";
import {CountryData} from "../../../models";
import {NgOptimizedImage} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  selector: 'country-list',
  standalone: true,
    imports: [ NgOptimizedImage ],
  templateUrl: './country-list.component.html',
  styleUrl: './country-list.component.scss'
})
export class CountryListComponent implements OnInit, OnDestroy {
    @Input({ required: true }) inputControl!: FormControl;
    showCountry: boolean = false;
    clickOutsideSubs: Subscription | undefined;

    constructor(
        public forms: FormsService,
        public settings: SettingsService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.clickOutsideSubs = this.settings.clickOutsideToClose$.subscribe(value => {
            const modulesCountry = this.forms.showModuleCountry[this.settings.selectedModule.id];
            if (value === false && modulesCountry && modulesCountry.show === true) {
                this.forms.showModuleCountry[this.settings.selectedModule.id].show = false;
            }
        });
    }

    ngOnDestroy() {
        this.clickOutsideSubs?.unsubscribe();
    }

    get countryInitial(): string {
        const country = this.forms.showModuleCountry[this.settings.selectedModule.id]?.country;
        return country?.initial ?? '';
    }

    setCountry($event: MouseEvent) {
        $event.stopPropagation();
        if (this.inputControl.value === null) {
            this.inputControl.setValue(this.settings.selectedModule.country);
        }
        if (this.settings.selectedModule.id === undefined) {
            this.showCountry = !this.showCountry;
        } else {
            this.forms.showModuleCountry[this.settings.selectedModule.id].show = !this.forms.showModuleCountry[this.settings.selectedModule.id].show;
        }
    }

    changeCountry(country: CountryData){
        this.forms.showModuleCountry[this.settings.selectedModule.id].country = country;

        this.settings.selectedModule.country = country.name;
        if (this.settings.selectedModule.id === undefined) {
            this.showCountry = !this.showCountry;
        } else {
            this.forms.showModuleCountry[this.settings.selectedModule.id].show = !this.forms.showModuleCountry[this.settings.selectedModule.id].show;
            this.inputControl.setValue(country);
        }
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
